import { put, call, take, fork } from 'redux-saga/effects'
import { getVideoSubtitlesSuccess } from 'src/reducers/course/action'
import { videoSubtitleUploadService, videoSubtitleDeleteService, videoSubtitleGetService, videoSubtitlePatchService } from 'src/api/media-video'
import { UPLOAD_VIDEO_SUBTITLE, DELETE_VIDEO_SUBTITLE, GET_VIDEO_SUBTITLES, PATCH_VIDEO_SUBTITLE } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* uploadSubtitleFlow(payload) {
  try {
    const { shopClipId, videoUrl, subtitleFile, language, label, isDefault, callback } = payload
    const response = yield call(
      videoSubtitleUploadService,
      shopClipId,
      videoUrl,
      subtitleFile,
      language,
      label,
      isDefault,
    )

    const uploadData = response.data?.data || response.data
    const returnedShopClipId = uploadData?.videoId || uploadData?.shopClipId || uploadData?.id || shopClipId

    // Refresh subtitle list from server after upload
    const listResponse = yield call(
      videoSubtitleGetService,
      returnedShopClipId,
      videoUrl,
    )
    const subtitles = listResponse.data?.data || listResponse.data || []
    yield put(getVideoSubtitlesSuccess(returnedShopClipId, subtitles))
    yield put(operationSuccess())

    if (callback) callback(returnedShopClipId)
  } catch (error) {
    yield put(operationFail(error))
  }
}

function* deleteSubtitleFlow(payload) {
  try {
    const { shopClipId, videoUrl, language, callback } = payload
    yield call(
      videoSubtitleDeleteService,
      shopClipId,
      videoUrl,
      language,
    )

    // Refresh subtitle list from server after delete
    const listResponse = yield call(
      videoSubtitleGetService,
      shopClipId,
      videoUrl,
    )
    const subtitles = listResponse.data?.data || listResponse.data || []
    yield put(getVideoSubtitlesSuccess(shopClipId, subtitles))
    yield put(operationSuccess())

    if (callback) callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export function* uploadSubtitleWatcher() {
  while (true) {
    const action = yield take(UPLOAD_VIDEO_SUBTITLE)
    const { payload } = action

    yield fork(generalSaga, uploadSubtitleFlow, payload)
  }
}

export function* deleteSubtitleWatcher() {
  while (true) {
    const action = yield take(DELETE_VIDEO_SUBTITLE)
    const { payload } = action

    yield fork(generalSaga, deleteSubtitleFlow, payload)
  }
}

function* getSubtitlesFlow(payload) {
  try {
    const { shopClipId, videoUrl, callback } = payload
    const response = yield call(
      videoSubtitleGetService,
      shopClipId,
      videoUrl,
    )

    const videoId = shopClipId
    const subtitles = response.data?.data || response.data || []
    yield put(getVideoSubtitlesSuccess(videoId, subtitles))
    yield put(operationSuccess())

    if (callback) callback(subtitles)
  } catch (error) {
    yield put(operationFail(error))
  }
}

export function* getSubtitlesWatcher() {
  while (true) {
    const action = yield take(GET_VIDEO_SUBTITLES)
    const { payload } = action

    yield fork(generalSaga, getSubtitlesFlow, payload)
  }
}

function* patchSubtitleFlow(payload) {
  try {
    const { shopClipId, videoUrl, language, patchBody, callback } = payload
    yield call(
      videoSubtitlePatchService,
      shopClipId,
      videoUrl,
      language,
      patchBody,
    )

    // Refresh subtitle list from server after patch
    const listResponse = yield call(
      videoSubtitleGetService,
      shopClipId,
      videoUrl,
    )
    const subtitles = listResponse.data?.data || listResponse.data || []
    yield put(getVideoSubtitlesSuccess(shopClipId, subtitles))
    yield put(operationSuccess())

    if (callback) callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export function* patchSubtitleWatcher() {
  while (true) {
    const action = yield take(PATCH_VIDEO_SUBTITLE)
    const { payload } = action

    yield fork(generalSaga, patchSubtitleFlow, payload)
  }
}
